module.exports = __webpack_public_path__ + "ag.svg?e367f0071dded1c3b0324cab84831168";